import LeadList from './LeadList';
import { withRouter } from "react-router-dom";

export default withRouter(LeadList);


// WEBPACK FOOTER //
// ./src/containers/Leads/LeadView.js